"use client";

import { useMemo, useSyncExternalStore } from "react";
import { getServerWishlist, wishlistStore } from "./wishlist";

/** The hearted works, shared by every card on the page and every open tab. */
export function useWishlist() {
  const ids = useSyncExternalStore(
    wishlistStore.subscribe,
    wishlistStore.getSnapshot,
    getServerWishlist,
  );
  const saved = useMemo(() => new Set(ids), [ids]);
  return { ids, saved, toggle: wishlistStore.toggle };
}
